import { Toaster } from 'sonner';
import type { ToastHandlerProps } from './ToastHandler.types';

export function ToastHandler({ position = 'bottom-right', richColors = true, ...props }: ToastHandlerProps) {
  return <Toaster position={position} richColors={richColors} {...props} />;
}

ToastHandler.displayName = 'ToastHandler';
